import { useLocation, Link } from "react-router-dom";
import Seo from "../components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Seo title="页面不存在 - 策驰漫画网" description="你访问的页面不存在，返回首页继续浏览漫画分类书库、人气排行与编辑精选推荐。" />

      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 py-24">
        <h1 className="font-heading text-8xl md:text-9xl text-primary-200 select-none pointer-events-none">404</h1>
        <div className="relative -mt-6 z-10">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground-950">页面未找到</h2>
          <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-4 text-base text-foreground-600">你访问的页面可能已被移除或地址有误。</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link to="/" className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors">返回首页</Link>
            <Link to="/fenlei" className="px-6 py-2.5 rounded-full bg-background-100 border border-background-200 text-foreground-700 text-sm font-semibold hover:bg-primary-100 transition-colors">浏览漫画库</Link>
          </div>
        </div>
      </div>
    </div>
  );
}